import React from 'react';
import { useMachineOrderProductionTypeInputQuery } from '../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../dum';
import { IMachine } from '../s-machine-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../helpers';

export function OrderProductionTypeInput() {
    const { data } = useMachineOrderProductionTypeInputQuery();
    const INPUT_NAME: keyof IMachine = 'order_production_type_id';

    return (
        <RhSingleAutocomplete
            itemText={'name'}
            itemValue={'id'}
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.order_production_type_id)}
            options={data?.getOrderProductionTypes || []}
        />
    );
}
